import { PARAMETER_SET, PARAMETER_EDITED } from 'src/app/redux/redux-types';
import { reduxActorBookTypes } from 'src/types';

export const parameterDefaultState: reduxActorBookTypes.StateType = {
  parameterList: [],
};

export const actorBookReducer = (
  state = parameterDefaultState,
  action: reduxActorBookTypes.ActionType,
): reduxActorBookTypes.StateType => {
  switch (action.type) {
    case PARAMETER_SET:
      return {
        ...state,
        parameterList: action.payload,
      };
    case PARAMETER_EDITED:
      return {
        ...state,
        parameterList: state.parameterList.map((param: any) =>
          param.name === action.payload.name ? action.payload : param,
        ),
      };

    default:
      return state;
  }
};
